import { css } from '@emotion/core';

import { Theme } from 'src/design-system/theme';

import type { Props } from './ServerStatusCard';

const container = (props: Props) => (theme: Theme) =>
  css`
    ${props.borderTopColor &&
    css`
      border-top: 2px solid ${theme.colors[props.borderTopColor]};
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    `}
  `;

const inner = (props: Props) => (theme: Theme) =>
  css`
    ${props.borderTopColor &&
    css`
      margin-top: -2px;
    `}
  `;

export const style = { container, inner };
